<template>
  <b-col cols="12" sm="4" class="current-setup pt-4">
    <b-row class="justify-content-center">
      <b-col cols="12" lg="10">
        <b-row>
          <b-col>
            <h4 class="mb-5 font-weight-light">Current Setup</h4>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="Select a country" class="current-setup-label">
              <multiselect v-model="country" :options="countries" label="name" track-by="id" :show-labels="false" :disabled="isLoading" :allow-empty="false"></multiselect>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="Select a breakout" class="current-setup-label">
              <multiselect v-model="breakout" :options="breakouts" label="name" track-by="id" :show-labels="false" :allow-empty="false" :disabled="isLoading"></multiselect>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button variant="primary" @click.prevent="loadSetup" :disabled="isLoading">Load current setup</b-button>
          </b-col>
        </b-row>
        <b-row v-if="loadGraph">
          <b-col>
            <iframe :src="kibanaIframeUrl" height="400" width="100%" frameBorder="0"></iframe>
            <p>
              <a :href="kibanaUrl" target="_blank" class="icon-container">
                <i class="material-icons">open_in_new</i>
                <span>Kibana link</span>
              </a>
            </p>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import {fetchBreakoutsByCountryId} from '@/api/routing'
export default {
  async created () {
    await this.loadCountries()
    this.country = this.getCountryById(this.$store.state.tests.countryId)
    this.loadBreakouts(this.$store.state.tests.countryId)
  },
  computed: {
    ...mapGetters({
      countries: 'countries/countries',
      getCountryById: 'countries/getCountryById'
    })
  },
  methods: {
    ...mapActions({
      loadCountries: 'countries/loadCountries'
    }),
    loadSetup () {
      if (this.breakout.id !== undefined) {
        this.setIframeUrl()
        this.loadGraph = true
      } else {
        this.$toastr.i('Select a breakout')
      }
    },
    setIframeUrl () {
      this.kibanaUrl = `https://1c69970c1b544a44b643f9c7182f37c2.us-east-1.aws.found.io:9243/app/kibana#/dashboard/b1312bb0-5750-11e8-a4cd-91a952830ff4?_g=(refreshInterval%3A(display%3AOff%2Cpause%3A!f%2Cvalue%3A0)%2Ctime%3A(from%3Anow-14d%2Fd%2Cmode%3Arelative%2Cto%3Anow))&_a=(description:'',filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'cdr_*',key:DestinationCountry.keyword,negate:!f,type:phrase,value:${this.country.id}),query:(match:(DestinationCountry.keyword:(query:${this.country.id},type:phrase)))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'cdr_*',key:Destination.keyword,negate:!f,type:phrase,value:'${this.breakout.id}'),query:(match:(Destination.keyword:(query:'${this.breakout.id}',type:phrase))))),options:(darkTheme:!f),viewMode:view)`
      this.kibanaIframeUrl = this.kibanaUrl + '&embed=true'
    },
    loadBreakouts (countryId) {
      this.isLoading = true
      this.breakout = {}
      fetchBreakoutsByCountryId(countryId).then((response) => {
        this.isLoading = false
        this.breakouts = Object.values(response)
      })
    }
  },
  watch: {
    country: {
      handler (newValue) {
        if (newValue !== undefined) {
          this.loadBreakouts(newValue.id)
        }
      }
    }
  },
  data () {
    return {
      country: {},
      breakout: {},
      breakouts: [], // breakouts local state
      kibanaUrl: '',
      kibanaIframeUrl: '',
      kibanaId: process.env.KIBANA_CURRENT_SETUP_ID,
      loadGraph: false,
      isLoading: false
    }
  }
}
</script>

<style lang="scss" scoped>
.current-setup {
  background-color: #FAFAFA;
  border-left: #DDDDDD solid 1px;
}
.current-setup-label {
  font-size: 14px;
  color: #687178;
}
iframe{
  margin-top: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/CurrentSetup.vue